import Api from "../axios"

export const getUserDetails = async () =>{
    return await Api.get('/show_data')
}